module.exports = __webpack_public_path__ + "static/media/PN.94380221.svg";